export class GLBatchSummaryItemResultDto {
    glAccountNumber: string;
    glAccountDisplayText: string;
    debitAmount: number;
    creditAmount: number;
    description: string;
}
